import api from 'services/api/microfwk';
import _ from 'lodash';

export const getEpgChannel = (params = {}) =>
  api
    .get('/services/epg/channel', {
      params,
    })
    .then(({ data }) => data)
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      return error;
    });

export const getEpgLineUp = (params = {}) =>
  api
    .get('/services/epg/lineup', {
      params,
    })
    .then(({ data }) => data)
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      return error;
    });


